export const updateStorageInventoriesArr = (item , list ) => {
  let f = false;
  let arr = [];

  if (item.id) {
    for (let lItem of list) {
      if (lItem.id == item.id) {
        arr.push(item);
        f = true;
      } else {
        arr.push(lItem);
      }
    }
    if (!f) arr.push(item);

  } else {
    for (let lItem of list) {
      if (lItem.inventory_id == item.inventory_id) {
        arr.push(item);
        f = true;
      } else {
        arr.push(lItem);
      }
    }
    if (!f) arr.push(item);
  }

  return JSON.parse(JSON.stringify(arr));
};
